export default "__VITE_ASSET__BYxrna9M__"